<template>
  <AlertModalBootstrapVue />
</template>

<script>

export default {
  components: {
    AlertModalBootstrapVue: () => import('@/libs/Alert/components/AlertModalBootstrapVue.vue'),
  },
};

</script>

<style lang="scss">

.alert-box.modal {
  & ~ .modal-backdrop {
    background-color: rgba(0, 0, 0, .6);
  }

  .modal-header {
    display: flex;
    align-items: center;
    padding: 0;

    .modal-title {
      padding: 10px 1rem;
      font-size: 1.1rem;
    }

    .close {
      background: transparent;
      margin: 0;
      border: none;
      padding: 0 20px;
      font-size: 2rem;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;

    .button-reject {
      margin-right: 20px;
    }
  }
}

</style>
